import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../queries';
import { unwrap } from './useEntityLabel';

/**
 * The id of the policy a quote converted into, or undefined while the quote
 * has not bound. Before binding, a renewal quote's `policyId` holds the policy
 * it renews, so the id only counts once the quote carries a `policyNumber`.
 */
export function convertedPolicyId(
  quote: Record<string, unknown> | undefined
): string | undefined {
  if (!quote?.policyNumber || typeof quote.policyId !== 'string') {
    return undefined;
  }
  return quote.policyId || undefined;
}

/**
 * For pages keyed on a quote id that show a policy (Rating View). Shares the
 * page's own quote-details cache entry, so it adds no request.
 */
export function useConvertedPolicyId(
  quoteId: string | undefined,
  product: string | undefined
): string | undefined {
  const { data } = useQuery({
    ...queries.quotes.detail(quoteId as string, product as string),
    select: (res: unknown) => unwrap(res as Record<string, unknown>),
    enabled: Boolean(quoteId) && Boolean(product),
  });
  return convertedPolicyId(data);
}
